import { render } from "./InsightsList.vue?vue&type=template&id=48b61147"
import script from "./InsightsList.vue?vue&type=script&lang=js"
export * from "./InsightsList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__